/**
 * Ryan O'Dowd
 * 2024-10-30
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = () => {
  return {
    container: {
      flex: 1,
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 8,
      gap: 16,
    },
    avoidKeyboard: {
      paddingBottom: Platform.OS === 'ios' ? '50%' : 0, // @TODO: is this sufficent for avoiding keyboard on smaller screens // @TODO: bad solution
    },
  };
};

export default getStyles;
